export default {
  getTicket(state) {
    return state.ticket;
  },
  getTicketDefaultObjections(state) {
    return state.defaultObjections;
  },
  getTickets(state) {
    return state.tickets;
  },
  getTicketsByState(state) {
    return state.ticketsByState;
  },
  getNewTickets(state) {
    return state.newTickets;
  },
  getSelectedTicketId(state) {
    return state.ticketId;
  },
  getShowTicketDetailDrawer(state) {
    return state.showTicketDetailDrawer;
  },
  getShowTicketDetailDrawerSection(state) {
    return state.showTicketDetailDrawerSection;
  },
  getTicketDownloads(state) {
    return state.ticketsDownloads;
  },
  getTicketPrioritiesColors(state) {
    return state.defaultPrioritiesColors;
  },
};
